import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const EnhancedCheckoutConsumerSearch = loadable(
  () => import('./ConsumerSearch'),
  {
    fallback: <LoadingScreen />,
  },
);

export const EnhancedCheckoutError = loadable(() => import('./Error'), {
  fallback: <LoadingScreen />,
});

export default EnhancedCheckoutConsumerSearch;
